import { NavLink } from "react-router";

import Avatar from "@/design/components/Avatar";
import { viAddressBook } from "@sippy-platform/valkyrie";

import { Card, List, ListItem, ListItemAvatar, ListItemButton, ListItemText } from "@mui/material";
import PropTypes from "prop-types";

export default function PhonebookCard({ phonebook }) {
  return (
    <Card>
      <List>
        <ListItem disablePadding>
          <ListItemButton component={NavLink} to={`${phonebook.id}`}>
            <ListItemAvatar>
              <Avatar text={phonebook.name} icon={viAddressBook} />
            </ListItemAvatar>
            <ListItemText primary={phonebook.name} />
          </ListItemButton>
        </ListItem>
      </List>
    </Card>
  );
}

PhonebookCard.propTypes = {
  phonebook: PropTypes.object,
};
